<template>
	<div class="innerBox">
		<h2 class="mb-4">Sejarah Kwitansi</h2>

		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox" style="padding:0">
				<div class="col row">
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Cari</label>
						<input
							type="text"
							class="form-control"
							v-on:keyup.enter="vue_universal_table.update++"
							placeholder="Ketik teks"
							style="height: 43px;"
							v-model="table.filter.search_param"
						/>
					</div>
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tanggal</label>
						<flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>
					</div>
					<div
						class="col-md-3"
						style="display: flex; flex-direction: column-reverse"
						:class="mobile ? 'pt-20' : ''"
					>
						<button
							type="button"
							class="btn btn-primary"
							style="height:38px; margin-bottom:0.5%"
							@click="table.update++"
						>
							Filter
						</button>
					</div>
				</div>
			</div>
		</panel>


		<vue-universal-table 
			:filter="table.filter"
			:update="table.update"
			api_url="/api/v1/workorder/print/historicalPaginated"
			:buttons="table.buttons"
			@onKePembayaran="paymentPage"
		/>
	</div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import Vue_universal_table from '../../../../components/table/vue_universal_table.vue';

export default {
	components: {
		Multiselect,
Vue_universal_table,
	},
	data() {
		return {
			selected: {
				date: "",
			},
			rangeConfig: {
				mode: "range",
				altInput: true,
				altInputClass: "form-control input flatpickr-input w-100",
				animate: !this.isRTL(),
			},
			table: {
				filter: {
					search_param: "",
					start: null,
					end: null,
				},
				update : 0,
				buttons : [{
					title : 'KePembayaran',
					variable : 'nomor_workorder',
					class : 'btn btn-primary'
				}]
			},
			mobile : this.isMobile()
		};
	},
	watch: {
		"selected.date"() {
			if (this.selected.date.includes("to")) {
				let splitDateRange = this.selected.date.split(" to ");
				this.table.filter.start = splitDateRange[0];
				this.table.filter.end = splitDateRange[1];
			} else {
				this.table.filter.start = this.selected.date;
				this.table.filter.end = this.selected.date;
			}
		},
	},
	methods : {
		paymentPage (work_order_code) {
			this.$router.push({ name : 'FinanceWorkOrderPayment', query : { form_code : work_order_code.split('"').join("") , from : 'FinanceKwitansiHistory'} })
		}
	}
};
</script>
